import { AfterViewInit, Component, OnInit, ViewChild, NgZone, ElementRef, VERSION, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { DOCUMENT } from '@angular/common';
import { logbaseService } from '../../services/logbase.service';
import { dataService } from '../../services/data.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

import { dateFormatPipe } from '../../pipes/dateFormatPipe'
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'

export interface SupplierAddressData{
  partNumber:any;
  supplierCode:any;
  supName:any;
  prodPoint:any;
  shipPoint:any;


}

@Component({
  selector: 'app-supplier-database-address',
  templateUrl: './supplier-database-address.component.html',
  styleUrls: ['./supplier-database-address.component.scss']
})
export class SupplierDatabaseAddressComponent implements OnInit {
  csvData: any[];
  detailedparts: any;
  notallowed: boolean;
  settingssuppliercode: any;
  supplierNameList: any[];
  supplierCodeList: any[];
  supplierNames: any;
  suppliernames: any;
  itemSelectedSupplierName: any = [];
  settingssupplierName: any;
  userIDTaken: boolean;
  itemSelectedSupplierCode: any = [];

  supplierCodes: any;
  suppliercodes: any;

  newPartsData: any[] = [];
  parts: any;
  srchValue:any

  // ng2-table code

  public rows: Array<any> = [];
  public columns: Array<any>
  public page: number = 1;
  public itemsPerPage: number = 800;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  displayedColumns = ['partNumber', 'supplierCode', 'suppName', 'prodPoint','shipPoint'];
  dataSource: MatTableDataSource<SupplierAddressData[]>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public config: any
  private data: Array<any> = [];

  // ng2-table code ends

  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: any, private logbaseService: logbaseService,
    private dataService: dataService, private spinner: NgxSpinnerService, private translate: TranslateService,
    private httpClient: HttpClient, private ref: ChangeDetectorRef, private toaster: ToastrService) {
      this.columns = [
        { title: this.translate.instant('PARTNO'), name: 'partNumber' },
        { title: this.translate.instant('SUPPLIERCODE'), name: 'supplierCode' },
        { title: this.translate.instant('Supplier Name'), name: 'suppName' },
        { title: this.translate.instant('PRODPOINT'), name: 'prodPoint' },
        { title: this.translate.instant('SHIPPINGPOINT'), name: 'shipPoint' }
      ];
      this.config = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table-striped', 'table-bordered']
      };
    

  }

  ngOnInit() {
    this.spinner.show();
    this.userIDTaken = true;
    this.notallowed = true;
    // this.onChangeTable(this.config, true);
    var supplierCodeListArr = [];
    this.logbaseService.getSupplierCodeAddress()
      .subscribe(result => {
        this.supplierCodes = result.response;
        this.spinner.hide();
        this.supplierCodes.forEach(function (value, key) {
          supplierCodeListArr.push({ "id": key + 1, "itemName": value });
          // this.spinner.hide();
        });
        this.supplierCodeList = supplierCodeListArr;
      });
    var supplierNameArr = [];
    // this.spinner.show();
    this.logbaseService.getSupplierNameAddress()
      .subscribe(result => {
        this.supplierNames = result.response;
        this.spinner.hide();
        this.supplierNames.forEach(function (value, key) {
          supplierNameArr.push({ "id": key + 1, "itemName": value });
        });
        this.supplierNameList = supplierNameArr;
      });
   
    this.settingssuppliercode = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: this.translate.instant("Select Supplier Code"),
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      itemsShowLimit: 4,
      limitSelection: 10
    };

    this.settingssupplierName = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: this.translate.instant("Select Supplier Name"),
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      itemsShowLimit: 4,
      limitSelection: 10
    };
  }
  exportCSV() {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: ['Part Number', 'Supplier Code', 'Supplier Name', 'Production Point', 'Shipping Point']
    };
    new AngularCsv(this.csvData, 'Supplier Address (Database)', options);

  }
  onSingleSelectSupplierCode(item: any) {


    this.itemSelectedSupplierCode.push(item.itemName);
    this.userIDTaken = false;
  }
  onDeSelectSupplierCode(yes: any) {

    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedSupplierCode.indexOf(yes.itemName);
    this.itemSelectedSupplierCode.splice(index, 1);
    if (this.itemSelectedSupplierCode.length == 0 || this.itemSelectedSupplierName.length == 0) {
      this.userIDTaken = true;
    }
    else {
      this.userIDTaken = false;
    }
  }

  onSelectAllSupplierCode(yes: any) {
    yes.forEach(element => {
      this.itemSelectedSupplierCode.push(element.itemName);

    });
    this.userIDTaken = false;
  }
  DeSelectAllSupplierCode(yes: any) {

    this.itemSelectedSupplierCode = [];
    this.userIDTaken = true;
  }

  onSingleSelectSupplierName(item: any) {


    this.itemSelectedSupplierName.push(item.itemName);
    this.userIDTaken = false;
  }
  onDeSelectSupplierName(yes: any) {

    let index = this.itemSelectedSupplierName.indexOf(yes.itemName);
    this.itemSelectedSupplierName.splice(index, 1);
    if (this.itemSelectedSupplierName.length == 0 || this.itemSelectedSupplierCode.length == 0) {
      this.userIDTaken = true;
    }
    else {
      this.userIDTaken = false;
    }
  }

  onSelectAllSupplierName(yes: any) {
    yes.forEach(element => {
      this.itemSelectedSupplierName.push(element.itemName);

    });
    this.userIDTaken = false;
  }
  DeSelectAllSupplierName(yes: any) {

    this.itemSelectedSupplierName = [];
    this.userIDTaken = true;
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name] != undefined) {
          if (item[column.name].toString().match(this.config.filtering.filterString)) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    var pageNo;
    var sortData;

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value.name,
          sort: value.sort
        }
      }
    });

    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;

    let userSuppCode = userDetJson.supplierCode;
    var dataToSend = {
      filteredDeliveryPoints: [],
      filteredLineNumbers: [],
      filteredPartNumber: [],
      filteredSupplierCode: this.itemSelectedSupplierCode,
      filteredSupplierName: this.itemSelectedSupplierName,
      loginId: userDetJson.loginId,
      pageNum: pageNo,
      partStatus: "",
      roleId: userRoleId,
      searchValue: this.srchValue,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: "ASC",
      supplierCodes: userSuppCode
    }

    var shippingpointCity;
    var shippingpointCountry;
    var shippingpointPref;
    var shippingpointStreet;

    var ProdPointCountry;
    var ProdPointCity;
    var ProdPointPref;
    var ProdPointStreet;
    this.spinner.show();
    this.logbaseService.getApprovedAddressPage(dataToSend)
      .subscribe(result => {
        this.detailedparts = result;
        
        this.spinner.hide();
        var partsArray;
        var detailsData = [];
        if (this.detailedparts.response.length == 0) {
          this.translate.get('No Records Found').subscribe(res => {
            this.toaster.warning(res);
          })
          this.notallowed = true;
        }
        else {
          this.notallowed = false;
          this.detailedparts.response.forEach(function (value, key) {
            if (value.shippingList) {
              shippingpointCity = value.shippingList[0].shippingPointaddrCity;
              shippingpointCountry = value.shippingList[0].shippingPointaddrCountry;
              shippingpointPref = value.shippingList[0].shippingPointaddrPrefecture;
              shippingpointStreet = value.shippingList[0].shippingPointaddrStreet;

            }

            else {
              shippingpointCity = " ";
              shippingpointCountry = " ";
              shippingpointPref = " ";
              shippingpointStreet = " ";
            }

            if (value.ProdPointAddrCountry) {
              ProdPointCountry = value.ProdPointAddrCountry;
            }
            else {
              ProdPointCountry = " ";
            }
            if (value.prodPointAddrCity) {
              ProdPointCity = value.prodPointAddrCity;
            }
            else {
              ProdPointCity = " ";
            }
            if (value.prodPointAddrPrefecture) {
              ProdPointPref = value.prodPointAddrPrefecture

            }
            else {
              ProdPointPref = " ";
            }
            if (value.ProdPointStreet) {
              ProdPointStreet = value.ProdPointStreet
            }
            else {
              ProdPointStreet = " ";
            }
            partsArray = {
              partNumber: value.partNumber,
              supplierCode: value.supplierCode,
              suppName: value.supplierNameEN,
              prodPoint: ProdPointPref + " " + ProdPointStreet + " " + ProdPointCity + " " + ProdPointCountry,
              shipPoint: shippingpointPref + shippingpointStreet + shippingpointCity + " " + shippingpointCountry
            };
            detailsData.push(partsArray);
          });
        };
        this.csvData = detailsData;
        // this.dataSource=new MatTableDataSource<SupplierAddressData[]>(detailsData)
      });



    this.logbaseService.getApprovedAddressPage(dataToSend)
      .subscribe(result => {

        this.parts = result;
        var partArr;
        var partsData = [];
        if (this.parts.response.length == 0) {
          this.notallowed = true;
        }
        else {
          this.notallowed = false;
          this.parts.response.forEach(function (value, key) {
            if (value.shippingList) {
              shippingpointCity = value.shippingList[0].shippingPointaddrCity;
              shippingpointCountry = value.shippingList[0].shippingPointaddrCountry;
              shippingpointPref = value.shippingList[0].shippingPointaddrPrefecture;
              shippingpointStreet = value.shippingList[0].shippingPointaddrStreet;

            } else {
              shippingpointCity = " ";
              shippingpointCountry = " ";
              shippingpointPref = " ";
              shippingpointStreet = " ";
            }

            if (value.ProdPointAddrCountry) {
              ProdPointCountry = value.ProdPointAddrCountry;
            }
            else {
              ProdPointCountry = " ";
            }
            if (value.prodPointAddrCity) {
              ProdPointCity = value.prodPointAddrCity;
            }
            else {
              ProdPointCity = " ";
            }
            if (value.prodPointAddrPrefecture) {
              ProdPointPref = value.prodPointAddrPrefecture

            }
            else {
              ProdPointPref = " ";
            }
            if (value.ProdPointStreet) {
              ProdPointStreet = value.ProdPointStreet
            }
            else {
              ProdPointStreet = " ";
            }

            partArr = {
              // partNumber: '<a class="partno_column" href="#/partDetails/partsInfo/' + value._id + '">' + value.partNumber + '</a>',
              partNumber:value.partNumber,
              packageId:value._id,
              supplierCode: value.supplierCode,
              suppName: value.supplierNameEN,
              prodPoint: ProdPointPref + " " + ProdPointStreet + " " + ProdPointCity + " " + ProdPointCountry,
              shipPoint: shippingpointPref + " " + shippingpointStreet + " " + shippingpointCity + " " + shippingpointCountry
            };
            partsData.push(partArr);
          });
        };
        this.newPartsData = partsData;
        this.data = partsData;
        this.dataSource=new MatTableDataSource<SupplierAddressData[]>(this.newPartsData)
        this.length = this.parts.response.totalElements;
        this.columns = [

          { title: this.translate.instant('PARTNO'), name: 'partNumber' },
          { title: this.translate.instant('SUPPLIERCODE'), name: 'supplierCode' },
          { title: this.translate.instant('Supplier Name'), name: 'suppName' },
          { title: this.translate.instant('PRODPOINT'), name: 'prodPoint' },
          { title: this.translate.instant('SHIPPINGPOINT'), name: 'shipPoint' }
        ];
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.rerenderTable(this.config, true);
        this.config.filtering.filterString = '';
        this.ref.detectChanges();
      });
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }

  public onCellClick(data: any): any {
  }
}